"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingOffersResponseDto = instanceOfListingOffersResponseDto;
exports.ListingOffersResponseDtoFromJSON = ListingOffersResponseDtoFromJSON;
exports.ListingOffersResponseDtoFromJSONTyped = ListingOffersResponseDtoFromJSONTyped;
exports.ListingOffersResponseDtoToJSON = ListingOffersResponseDtoToJSON;
exports.ListingOffersResponseDtoToJSONTyped = ListingOffersResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var SellerListingOfferDto_1 = require("./SellerListingOfferDto");
/**
 * Check if a given object implements the ListingOffersResponseDto interface.
 */
function instanceOfListingOffersResponseDto(value) {
    if (!('offers' in value) || value['offers'] === undefined)
        return false;
    return true;
}
function ListingOffersResponseDtoFromJSON(json) {
    return ListingOffersResponseDtoFromJSONTyped(json, false);
}
function ListingOffersResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'offers': (json['offers'].map(SellerListingOfferDto_1.SellerListingOfferDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function ListingOffersResponseDtoToJSON(json) {
    return ListingOffersResponseDtoToJSONTyped(json, false);
}
function ListingOffersResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'offers': (value['offers'].map(SellerListingOfferDto_1.SellerListingOfferDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
